<template>
	<vs-popup
		:title="'Éditer les concurrents de ' + society.name"
		:active.sync="popupActive"
		style="z-index: 99999"
	>
		<!-- Import Info Popup -->
		<vs-popup
			title="Résultats de l'importation"
			:active.sync="importResultsPopup"
			style="z-index: 999991"
		>
			<div class="p-4 flex flex-col items-center">
				<div class="text-center mb-6">
					<h3 class="text-xl font-medium mb-2">Détails de l'importation</h3>
					<div class="flex flex-col space-y-2">
						<div class="flex space-x-2">
							<div class="font-medium">Total importé:</div>
							<div>{{ importStats.imported }}</div>
						</div>
						<div class="flex space-x-2">
							<div class="font-medium">Doublons ignorés:</div>
							<div>{{ importStats.duplicates }}</div>
						</div>
					</div>
				</div>
				<vs-button @click="importResultsPopup = false" class="w-1/2"
					>Fermer</vs-button
				>
			</div>
		</vs-popup>
		<!-- Batch Delete Confirmation Popup -->
		<vs-popup
			title="Êtes-vous sûr de vouloir supprimer ?"
			:active.sync="batchDeleteConfirmationPopup"
			style="z-index: 9999999"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="removeBatch()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button
						class="mt-2 w-full"
						@click="batchDeleteConfirmationPopup = false"
					>
						Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<!-- Single Delete Confirmation Popup -->
		<vs-popup
			title="Êtes-vous sûr de vouloir supprimer ?"
			:active.sync="deleteConfirmationPopup"
			style="z-index: 9999999"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="remove(selectId)"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button
						class="mt-2 w-full"
						@click="deleteConfirmationPopup = false"
					>
						Non</vs-button
					>
				</div>
			</div>
		</vs-popup>

		<div>
			<div v-if="isLoading" class="text-center">
				<circular-loader />
			</div>
			<div v-else>
				<div class="keyword-editor">
					<!-- Add Brand Input -->
					<div class="add-keyword">
						<input
							v-model="newCompetitor"
							placeholder="Ajouter nouvelle concurrent..."
							@keyup.enter="add"
						/>
						<input
							v-if="newCompetitor"
							v-model="newComment"
							placeholder="Ajouter commentaire ..."
							@keyup.enter="add"
						/>
						<vs-button @click="add" color="primary" type="filled"
							>Ajouter</vs-button
						>
					</div>

					<!-- CSV Import/Export -->
					<div
						class="import-csv mt-4 flex justify-end items-center w-full space-x-5"
					>
						<div class="flex items-center space-x-2">
							<input
								type="file"
								ref="fileInput"
								style="display: none"
								accept=".xlsx, .xls, .csv"
								@change="handleCSVUpload"
							/>
							<vs-button
								@click="$refs.fileInput.click()"
								color="warning"
								type="border"
								>Import XLSX</vs-button
							>
							<a
								href="https://docs.google.com/spreadsheets/d/1VaPuVSOELmLXDBTAYgpFDxDXYEUFy82_PWNhaRh5tSk/edit?gid=0#gid=0"
								target="_blank"
								rel="noopener noreferrer"
							>
								<vx-tooltip
									:text="'Premier ligne reservée pour les entêtes : Concurrent, Commentaire'"
									placement="top"
								>
									<vs-icon
										icon="description"
										size="small"
										color="black"
									></vs-icon>
								</vx-tooltip>
							</a>
						</div>

						<vs-button
							icon="cloud_download"
							color="primary"
							@click="exportToExcel"
						>
							Exporter
						</vs-button>
					</div>

					<!-- Brands Table -->
					<vs-table
						multiple
						v-model="selected"
						pagination
						max-items="30"
						search
						:data="competitorChips"
					>
						<template slot="header">
							<div class="pl-5 vx-row w-full space-x-5">
								<strong class="float-right"
									>Nombre de concurrents affichées :
									{{ competitorChips.length }}</strong
								>
								<div v-if="selected.length > 0">
									<vs-button
										color="danger"
										type="border"
										@click="batchDeleteConfirmationPopup = true"
									>
										Supprimer
									</vs-button>
								</div>
							</div>
						</template>
						<template slot="thead">
							<vs-th style="pointer-events: auto" sort-key="isFav"
								>Favoris client</vs-th
							>
							<vs-th style="pointer-events: auto" sort-key="competitor_name">
								Concurrents
							</vs-th>
							<vs-th style="pointer-events: auto" sort-key="comment">
								Commentaire
							</vs-th>
							<vs-th sort-key=""> Actions </vs-th>
						</template>

						<template slot-scope="{ data }">
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td :data="data[indextr].competitor_name">
									<vs-icon
										@click.stop="event.stopPropagation()"
										:icon="data[indextr].isFav ? 'star' : 'star_border'"
										size="medium"
										style="color: #08b0b9"
										@click="toggleIsFav(data[indextr])"
									></vs-icon>
								</vs-td>

								<vs-td :data="data[indextr].competitor_name">
									<div v-if="data[indextr].isEditing">
										<input
											v-model="data[indextr].editName"
											class="edit-input"
											@keyup.enter="saveEdit(data[indextr])"
										/>
									</div>
									<div v-else>
										{{ data[indextr].competitor_name }}
									</div>
								</vs-td>

								<vs-td :data="data[indextr].competitor_name">
									<div v-if="data[indextr].isEditing">
										<input
											v-model="data[indextr].editComment"
											class="edit-input"
											@keyup.enter="saveEdit(data[indextr])"
										/>
									</div>
									<div v-else>
										{{ data[indextr].comment || "" }}
									</div>
								</vs-td>

								<vs-td
									:data="data[indextr].competitor_name"
									class="flex-actions"
								>
									<vs-icon
										v-if="data[indextr].isEditing"
										icon="save"
										size="small"
										color="success"
										class="action-icon"
										@click.stop="saveEdit(data[indextr])"
									></vs-icon>
									<vs-icon
										v-else
										icon="edit"
										size="small"
										color="primary"
										class="action-icon"
										@click.stop="startEdit(data[indextr])"
									></vs-icon>
									<vs-icon
										icon="delete"
										size="small"
										color="danger"
										class="action-icon"
										@click.stop="onRemoveClick(data[indextr].id)"
									></vs-icon>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
			</div>
		</div>
	</vs-popup>
</template>
  
<script>
import XLSX from "xlsx";
import CircularLoader from "../widgets/loader/CircularLoader.vue";
import Society from "../../entities/Society";

export default {
	components: { CircularLoader },
	name: "BrandsManager",
	props: {
		society: {
			type: Object,
			required: true,
		},
		popupActive: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			competitors: [], // local copy to manipulate
			competitorFullChips: [], // full list of competitors
			competitorChips: [], // filtered list of competitors
			competitorChipsKey: 0,
			newCompetitor: "",
			newComment: "",
			nextId: 1,
			isLoading: false, // fallback id for new competitors
			searchQuery: "",

			selected: [], // selected competitors for deletion
			selectId: null, // id of the selected brand for single delete

			batchDeleteConfirmationPopup: false, // confirmation popup for batch delete
			deleteConfirmationPopup: false, // confirmation popup for single delete

			importResultsPopup: false,
			importStats: {
				imported: 0,
				duplicates: 0,
			},
		};
	},
	async created() {
		// Clone initial data and track max ID
		await this.getCompetitors();
	},
	watch: {
		searchQuery: {
			immediate: false,
			handler(query) {
				if (!query) {
					this.competitorChips = this.competitorFullChips;
				} else {
					this.competitorChips = this.competitorFullChips.filter((chip) =>
						chip.competitor_name.toLowerCase().includes(query.toLowerCase())
					);
				}
			},
		},
		competitorFullChips: {
			immediate: true,
			handler(data) {
				this.competitorChips = data;
				const maxId = data.reduce((max, k) => (k.id > max ? k.id : max), 0);
				this.nextId = maxId + 1;
			},
		},
	},
	methods: {
		startEdit(competitor) {
			// Set editing flags and prepare edit values
			this.$set(competitor, "isEditing", true);
			this.$set(competitor, "editName", competitor.competitor_name);
			this.$set(competitor, "editComment", competitor.comment || "");
		},

		async saveEdit(competitor) {
			try {
				const trimmedName = competitor.editName.trim();
				if (!trimmedName) {
					this.$vs.notify({
						title: "Erreur",
						text: "Le nom du concurrent ne peut pas être vide",
						color: "warning",
					});
					return;
				}

				const updateData = {
					competitor_name: trimmedName,
					comment: competitor.editComment,
				};

				await Society.updateCompetitor(updateData, competitor.id);

				// Update local data
				competitor.competitor_name = trimmedName;
				competitor.comment = competitor.editComment;
				competitor.isEditing = false;

				this.$vs.notify({
					title: "Succès",
					text: "Concurrent mis à jour avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la mise à jour du concurrent",
					color: "danger",
				});
				console.error(error);
			}
		},

		async toggleIsFav(brand) {
			try {
				await Society.updateCompetitor({ isFav: !brand.isFav }, brand.id);
				brand.isFav = !brand.isFav;
				this.$vs.notify({
					title: "Succès",
					text: "Concurrent mise à jour avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la mise à jour de la concurrent",
					color: "danger",
				});
				console.error(error);
			}
		},
		async getCompetitors() {
			try {
				this.isLoading = true;
				let competitors = await Society.getCompetitors(this.$props.society.id);
				this.competitors = competitors;

				// Add editing flags to all competitors
				competitors = competitors.map((comp) => ({
					...comp,
					isEditing: false,
					editName: "",
					editComment: "",
				}));

				this.competitorFullChips = competitors.reverse();
				this.competitorChips = this.competitorFullChips;
				this.competitorChipsKey++;
				this.isLoading = false;
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la récupération des concurrents",
					color: "danger",
				});
				console.error(error);
				this.isLoading = false;
			}
		},
		async add() {
			try {
				const trimmed = this.newCompetitor.trim();
				if (!trimmed) return;

				let body = {
					id: this.nextId++,
					society_id: this.$props.society.id || null,
					competitor_name: trimmed,
					comment: this.newComment,
					isFav: false,
					active: 1,
					isEditing: false,
				};
				await Society.addCompetitors([body], this.$props.society.id);
				this.competitorFullChips.unshift(body);

				this.newCompetitor = "";
				this.newComment = "";

				this.$vs.notify({
					title: "Succès",
					text: "Concurrent ajoutée avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de l'ajout de la concurrent",
					color: "danger",
				});
				console.error(error);
			}
		},
		onRemoveClick(id) {
			this.deleteConfirmationPopup = true;
			this.selectId = id;
		},
		async remove(id) {
			try {
				await Society.deleteCompetitors(id);
				this.competitorFullChips = this.competitorFullChips.filter(
					(k) => k.id !== id
				);
				this.deleteConfirmationPopup = false; // Close confirmation popup
				this.selectId = null; // Reset selected brand ID

				this.$vs.notify({
					title: "Succès",
					text: "Concurrent supprimée avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la suppression de la concurrent",
					color: "danger",
				});
				console.error(error);
			}
		},
		async removeBatch() {
			try {
				let ids = this.selected.map((k) => k.id);
				if (ids.length === 0) return;
				await Society.deleteBatchCompetitors(ids);

				this.competitorFullChips = this.competitorFullChips.filter(
					(k) => !ids.includes(k.id)
				);
				this.selected = []; // Clear selected competitors
				this.batchDeleteConfirmationPopup = false; // Close confirmation popup

				this.$vs.notify({
					title: "Succès",
					text: "Concurrents supprimées avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de la suppression des concurrents",
					color: "danger",
				});
				console.error(error);
			}
		},
		// Check if competitor already exists
		// Fixed check for competitor duplicates - handles null values
		isCompetitorDuplicate(competitorName) {
			if (!competitorName) return false;

			return this.competitorFullChips.some((comp) => {
				// Make sure both the competitor and the name exist before comparing
				return (
					comp &&
					comp.competitor_name &&
					comp.competitor_name.toLowerCase() === competitorName.toLowerCase()
				);
			});
		},

		// Updated import function for both CSV and XLSX with null checks
		handleCSVUpload(event) {
			const file = event.target.files[0];
			if (!file) return;

			// Check if file is CSV or XLSX
			const fileExtension = file.name.split(".").pop().toLowerCase();
			if (
				fileExtension !== "csv" &&
				fileExtension !== "xlsx" &&
				fileExtension !== "xls"
			) {
				this.$vs.notify({
					title: "Erreur",
					text: "Seuls les fichiers CSV et Excel (XLSX/XLS) sont pris en charge",
					color: "danger",
				});
				return;
			}

			const reader = new FileReader();
			reader.onload = async (e) => {
				try {
					let newCompetitors = [];
					let rows = [];
					const result = e.target.result;

					// Parse file content - works for both CSV and XLSX
					const data = new Uint8Array(result);
					const workbook = XLSX.read(data, { type: "array" });
					const sheet = workbook.Sheets[workbook.SheetNames[0]];
					rows = XLSX.utils.sheet_to_json(sheet, { header: 1 });

					// Track duplicates for notification
					let duplicateCount = 0;

					// Skip the first row (header)
					rows.slice(1).forEach((row) => {
						// Safely extract the competitor name and trim if exists
						const competitorName =
							row && row[0] ? row[0].toString().trim() : "";
						if (!competitorName) return;

						// Check if competitor already exists
						if (this.isCompetitorDuplicate(competitorName)) {
							duplicateCount++;
							return; // Skip this competitor
						}

						// Add the new competitor
						newCompetitors.unshift({
							id: this.nextId++,
							society_id: this.$props.society.id || null,
							competitor_name: competitorName,
							comment: row[1] ? row[1].toString() : "",
							isFav: row[2]
								? row[2].toString().toLowerCase() === "true" ||
								  row[2].toString().toLowerCase() === "oui"
								: false,
							active: 1,
							isEditing: false,
						});
					});
					// Import Stats Popup
					this.importStats.imported = newCompetitors.length;
					this.importStats.duplicates = duplicateCount;
					this.importResultsPopup = true;

					if (newCompetitors.length > 0) {
						// Add the competitors to the database
						await Society.addCompetitors(
							newCompetitors,
							this.$props.society.id
						);

						// Update local state
						this.competitorFullChips = newCompetitors.concat(
							this.competitorFullChips
						);
						this.competitorChipsKey++;

						let message = `${newCompetitors.length} concurrents importés avec succès`;
						if (duplicateCount > 0) {
							message += `, ${duplicateCount} doublons ignorés`;
						}

						this.$vs.notify({
							title: "Succès",
							text: message,
							color: "success",
						});
					} else if (duplicateCount > 0) {
						this.$vs.notify({
							title: "Information",
							text: `Aucun nouveau concurrent importé, ${duplicateCount} doublons ignorés`,
							color: "primary",
						});
					} else {
						this.$vs.notify({
							title: "Information",
							text: "Aucun concurrent à importer",
							color: "primary",
						});
					}

					// Reset file input
					this.$refs.fileInput.value = "";
				} catch (error) {
					this.$vs.notify({
						title: "Erreur",
						text: "Échec de l'importation des concurrents",
						color: "danger",
					});
					console.error(error);
				}
			};
			reader.readAsArrayBuffer(file);
		},
		exportToExcel() {
			try {
				const dataToExport = this.competitorChips.map((item) => ({
					Concurrent: item.competitor_name,
					Commentaire: item.comment || "",
					Favori: item.isFav ? "Oui" : "Non",
				}));

				const worksheet = XLSX.utils.json_to_sheet(dataToExport);
				const workbook = XLSX.utils.book_new();
				XLSX.utils.book_append_sheet(workbook, worksheet, "Concurrents");

				XLSX.writeFile(workbook, "export_concurrents.xlsx");

				this.$vs.notify({
					title: "Succès",
					text: "Concurrents exportées avec succès",
					color: "success",
				});
			} catch (error) {
				this.$vs.notify({
					title: "Erreur",
					text: "Échec de l'exportation des concurrents",
					color: "danger",
				});
				console.error(error);
			}
		},
	},
};
</script>
  
<style scoped>
.keyword-editor {
	padding: 20px;
}
.add-keyword input {
	padding: 10px;
	margin-right: 10px;
	border: 1px solid #ccc;
}
.chips-wrapper {
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
}
.edit-input {
	padding: 5px;
	border: 1px solid #ddd;
	border-radius: 4px;
	width: 100%;
}
.flex-actions {
	display: flex;
	gap: 10px;
}
.action-icon {
	cursor: pointer;
}
</style>